import { Box, useMediaQuery } from "@mui/material"
import { ReferanceCard, VideoCard } from "../../components"
import { useTranslation } from "react-i18next"
import {gaThumbnailUrl, gaVideoUrl, identifyingGAFilePath} from "../../../../assets/data"
import VisionLoss from "./VisionLoss"
import HallMarkDisease from "./HallMarkDisease"
import IntermediateDisease from "./IntermediateDisease"
import LesionAreas from "./LesionAreas"
import Progression from "./Progression"
import TransMsg from './transMessage'
import { desktopEdHubReferences, mobileEdHubReferences } from "../../../../assets/data/educationHub/referancesData"
import { theme } from "../../../../utils"

const IdentifyingGA = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    return (
        <Box>
            <VideoCard
                mainTitle={t(TransMsg.WATCH_AND_DISCOVER)}
                description={t(TransMsg.WATCH_AND_DISCOVER_DESCRIPTION)}
                downloadText={t(TransMsg.GA_BY_NUMBERS)}
                videoURL={gaVideoUrl}
                fileUrl={identifyingGAFilePath}
                thumbnailURL={gaThumbnailUrl}
            />
            <VisionLoss />
            <HallMarkDisease />
            <IntermediateDisease />
            <LesionAreas />
            <Progression />
            <ReferanceCard
                referanceData={isMobileX ? mobileEdHubReferences : desktopEdHubReferences}
            />
        </Box>
    )
}

export default IdentifyingGA
